<div class="body-2 p-6 bg-primary text-primary-contrast">
    <p>Created On</p>
    <div class="display-1">20 April 2022</div>
</div>

<mat-divider></mat-divider>

<table [dataSource]="dataSource" mat-table matSort class="w-full">
    <ng-container matColumnDef="recording">
        <th mat-header-cell *matHeaderCellDef>Recording</th>
        <td mat-cell *matCellDef="let row" class="text-secondary font-medium">
            <button
                class="ml-2 font-medium"
                color="primary"
                fxFlex="none"
                mat-mini-fab
                matTooltip="Play Recording"
                type="button"
            >
                <mat-icon [icIcon]="icPlay"></mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef>Remarks</th>
        <td mat-cell *matCellDef="let row" class="text-secondary font-medium">
            Remarks
        </td>
    </ng-container>

    <ng-container matColumnDef="recordedOn">
        <th mat-header-cell *matHeaderCellDef>Recorded On</th>
        <td mat-cell *matCellDef="let row" class="text-secondary font-medium">
            20 April 2022
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr
        mat-row
        *matRowDef="let row; columns: visibleColumns"
        class="hover:bg-hover trans-ease-out cursor-pointer"
    ></tr>
</table>
